import type React from 'react';

import styles from './FootNote.module.scss';

export interface FootNoteProps {
    children?: React.ReactNode;
}

function FootNote({ children }: FootNoteProps) {
    return <div className={styles.footnote}>{children}</div>;
}

export default FootNote;
export { FootNote };
